import * as React from "react";
import {createRoot} from "react-dom/client";
import MarketCapacity from "./MarketCapacity";
import {msalConfig} from "./config/authConfig";
import {PublicClientApplication} from "@azure/msal-browser";
import {MsalProvider} from "@azure/msal-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const container = document.getElementById("root");
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

export const msalInstance = new PublicClientApplication(msalConfig);


export const client = new QueryClient();

root.render(<MsalProvider instance={msalInstance}>
	<QueryClientProvider client={client}>
		<MarketCapacity/>
	</QueryClientProvider>
</MsalProvider>);
